module.exports = __webpack_public_path__ + "img/17-1_02.8d3d2aff.jpg";